module.exports = __webpack_public_path__ + "img/slide4.ae0b742b.png";